/* eslint-disable */
import AppService from '@/services/AppService';
import DividerLine from '@/components/Common/DividerLine';
import ValidatorService from '@/services/ValidatorService';
import RechargeFormPromotionInfo from './RechargeFormPromotionInfo';

export default {
  name: 'RechargeForm',
  components: {
    DividerLine,
    RechargeFormPromotionInfo
  },

  props: {
    minAmount: {
      type: Number,
      default: 0
    },
    maxAmount: {
      type: Number,
      default: 500
    },
    promotions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rechargeForm: {
        userNumber: null,
        userMoney: null,
        regulations: false,
        dataProcessing: false
      },
      // validUserNumber: false,
      // validUserMoney: false,
      isLoading: false,
      rules: {
        userNumber: [
          {required: true, validator: this.__validateUserNumber, trigger: 'blur'}
        ],
        userMoney: [
          {required: true, validator: this.__validateUserMoney, trigger: 'blur'}
        ],
        regulations: [
          {
            required: true,
            trigger: 'change',
            message: 'Pole jest wymagane',
            validator: this.__validateRegulations
          }
        ],
        dataProcessing: [
          {
            required: true,
            trigger: 'change',
            message: 'Pole jest wymagane',
            validator: this.__validateDataProcessing
          }
        ]
      }
    };
  },

  methods: {
    checkRegulations() {
      this.rechargeForm.regulations = !this.rechargeForm.regulations;
    },
    checkDataProcessing() {
      this.rechargeForm.dataProcessing = !this.rechargeForm.dataProcessing;
    },
    onlyNumber( $event ) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ( (keyCode < 48 || keyCode > 57) && keyCode !== 46 ) {
        $event.preventDefault();
      }
    },
    async submitForm( number, amount ) {
      const form = this.$refs.rechargeForm;
      form.validate(async ( valid ) => {
        if ( valid ) {
          this.isLoading = true;
          const paymentLink = await AppService.getRechargesPaymentLink({number, amount});
          this.isLoading = false;
          AppService.redirectToPay(paymentLink);
        }
      })
    },
// validators
    __validateUserNumber( rule, value, callback ) {
      if ( !ValidatorService.itShouldBeDefined(value) ) {
        callback(new Error('Pole jest wymagane!'));
        return;
      }
      if ( !ValidatorService.itShouldHaveOnlyDigits(value) ) {
        callback(new Error('Numer może zawierać tylko cyfry'));
        return;
      }

      if ( !ValidatorService.itShouldHaveLengthExactly(value, 9) ) {
        callback(new Error('Numer musi mieć dokładnie 9 cyfr'));
        return;
      }

      if ( !ValidatorService.itShouldNotBeenStartedWith(value, '48') ) {
        callback(new Error('Numer musi być wpisany bez prefiksu 48'));
        return;
      }

      if ( !ValidatorService.itShouldNotBeenStartedWith(value, '0') ) {
        callback(new Error('Numer nie może zaczynać się od zera'));
        return;
      }

      callback();
    },

    __validateUserMoney( rule, value, callback ) {
      if ( !ValidatorService.itShouldBeDefined(value) ) {
        callback(new Error('Pole jest wymagane!'));
        return;
      }
      if ( !ValidatorService.itShouldHaveOnlyDigits(value) ) {
        callback(new Error('Kwota może zawierać tylko cyfry'));
        return;
      }

      if ( !ValidatorService.itShouldBeNumberBetween(value, [ this.minAmount, this.maxAmount ]) ) {
        callback(new Error(`Kwota musi być w przedziale ${this.minAmount} - ${this.maxAmount} PLN`));
        return;
      }

      if ( !ValidatorService.itShouldNotBeenStartedWith(value, '0') ) {
        callback(new Error('Numer nie może zaczynać się od zera'));
        return;
      }
      callback();
    },

    __validateRegulations( rule, value, callback ) {
      if ( value === false ) {
        callback(new Error('Pole jest wymagane!'));
      }
      callback();
    },

    __validateDataProcessing( rule, value, callback ) {
      if ( value === false ) {
        callback(new Error('Pole jest wymagane!'));
      }
      callback();
    }
  }
}
